import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  caption: function caption() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      width: 100%;\n    "])));
  },
  container: function container() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      line-height: normal;\n    "])));
  }
});